import React from "react";

import { Navigate, useLocation } from "react-router-dom";
import { Router } from "ui/router/Router";
import StudentInviteLogin from "pages/UserLogin/StudentInviteLogin";
import suspenseWrapper from "utils/suspenseWrapper";
import UserSignIn from "pages/UserLogin/UserSignIn";
import TeacherSignup from "pages/UserLogin/TeacherSignup";
import CreateAccount from "pages/UserLogin/CreateAccount";
import ConnectCodeSignup from "pages/ConnectCodeSignup/ConnectCodeSignup";
import AnalyticsRouteWrapper from "utils/analytics/AnalyticsRouteWrapper";
import {
  PrivacyPolicy,
  StudentPrivacyNotice,
  UserAgreement,
  CodeOfConduct,
} from "pages/Policies";

export default function GuestApp() {
  const routes = [
    {
      index: true,
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_login_page">
          {suspenseWrapper(<UserSignIn />)}
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "connect",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_student_connect_code_signup_page">
          {suspenseWrapper(<ConnectCodeSignup />)}
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "connect/sign-up",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_student_introduction_page">
          {suspenseWrapper(<StudentInviteLogin />)}
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "connect/*",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_class_code_error_page">
          <Navigate to="/connect" replace />
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "educator_signup",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_educator_signup_page">
          {suspenseWrapper(<TeacherSignup />)}
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "create_account",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="viewed_select_user_type_page">
          <CreateAccount />
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "privacy-policy",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="clicked_privacy_policy_link">
          <PrivacyPolicy />
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "student-privacy-notice",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="clicked_student_privacy_notice_link">
          <StudentPrivacyNotice />
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "user-agreement",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="clicked_user_agreement_link">
          <UserAgreement />
        </AnalyticsRouteWrapper>
      ),
    },
    {
      path: "code-of-conduct",
      element: (
        <AnalyticsRouteWrapper analyticsPageName="clicked_code_of_conduct_link">
          <CodeOfConduct />
        </AnalyticsRouteWrapper>
      ),
    },
    { path: "*", element: <LoginRoute /> },
  ];

  return <Router routes={routes} />;
}

function LoginRoute() {
  // Capture the request URL that brought the user here so we can attempt to return the
  // user to that URL after they have authenticated.
  const location = useLocation();
  const nextPath = location.pathname + location.search;

  try {
    // Using SessionStorage here as a measure of protection to keep this from bleeding across
    // different tabs.
    sessionStorage.setItem("nextPath", nextPath);
  } catch (error) {
    // It's possible the user has storage disabled, so quietly allow this to fail.
  }

  return (
    <AnalyticsRouteWrapper analyticsPageName="viewed_guest_route_not_found_page">
      <Navigate to="/" />
    </AnalyticsRouteWrapper>
  );
}
